import database from 'model'
import AppConstants from 'model/models/AppConstants'
import { InheritanceNoticeMap } from 'types/api/changes'
import { CollectionType, Model } from 'types/model'

import Database from '../Database'

export interface InheritanceNotices {
  groupsExceedsInheritanceDepthLimit?: InheritanceNoticeMap
  groupsInheritanceBlockedByTier?: InheritanceNoticeMap
}

export const AppConstantsQuery = async () => {
  const appConstantsQuery = Database.getCollection<AppConstants>(
    CollectionType.APP_CONTSTANTS
  )
    .query()
    .fetch()
  const existing = (await appConstantsQuery)[0]

  if (existing === undefined) {
    // in case it's not exist, we create new one
    const newone = database.write<Model<AppConstants>>(async () => {
      return database
        .get<Model<AppConstants>>(AppConstants.table)
        .create((local) => {
          local.password = '90180948e4ec4e439b03e9c067d6bff7'
        })
    })

    return await newone
  }

  return existing
}

function replaceNoticeScope(
  current: InheritanceNoticeMap | undefined,
  incoming: InheritanceNoticeMap | undefined,
  groupIds?: string[]
): InheritanceNoticeMap {
  if (!groupIds) return incoming ?? {}

  const next = { ...(current ?? {}) }
  groupIds.forEach((groupId) => delete next[groupId])
  Object.entries(incoming ?? {}).forEach(([groupId, enabled]) => {
    if (groupIds.includes(groupId)) next[groupId] = enabled
  })
  return next
}

export async function updateInheritanceNotices(
  notices: InheritanceNotices,
  groupIds?: string[]
) {
  const constants = await AppConstantsQuery()

  return Database.write(async () => {
    return constants.update(() => {
      constants.groupsExceedsInheritanceDepthLimit = replaceNoticeScope(
        constants.groupsExceedsInheritanceDepthLimit,
        notices.groupsExceedsInheritanceDepthLimit,
        groupIds
      )
      constants.groupsInheritanceBlockedByTier = replaceNoticeScope(
        constants.groupsInheritanceBlockedByTier,
        notices.groupsInheritanceBlockedByTier,
        groupIds
      )
    })
  })
}
